import z from 'zod';

const envSchema = z.object({
  BUILD_ID: z.string().optional(),
  BUILD_NUMBER: z.string().optional(),
  PR_BRANCH: z.string().optional(),
  COMMIT_ID: z.string().optional(),
  PORT: z.string().default('3000'),
  NODE_ENV: z
    .enum(['development', 'production', 'test'])
    .default('development')
    .optional(),
  API_URL: z.string(),
  SUBSCRIPTION_KEY: z.string(),
  APPLICATIONINSIGHTS_CONNECTION_STRING: z.string(),
  AUTH_STATUS_URL: z.string(),
  LOGOUT_URL: z.string(),
  LOGIN_URL: z.string(),
});

export type Env = z.infer<typeof envSchema>;

/** Remove the VITE_ prefix from environment variables. */
export function removePrefix(env: object): Env {
  const result: Record<string, unknown> = {};
  for (const key of Object.keys(env)) {
    result[key.replace('VITE_', '')] = env[key as keyof typeof env];
  }
  return result as Env;
}

export default envSchema;
